import { PhraseInput, Spacer } from "@vericus/cadmus-ui";

import { WorkAttachmentSection } from "@/components/work-attachment-section/work-attachment-section";
import { useAppDispatch, useAppSelector } from "@/data/hooks";
import { selectAnswerSnapshot, setLocalSnapshot } from "@/features/authority";
import { readAnswerBlock } from "@/graphql/selectors";
import { Snapshot } from "@/stores/snapshot";

import * as styles from "./answer-form.css";

interface Props {
  answerBlockId: string;
  /** Field identifier */
  identifier: string;
  /** Whether the input is readonly */
  isReadonly?: boolean;
  /** Whether attachment is enabled */
  attachmentEnabled?: boolean;
  /** Whether LDB exam mode is enabled */
  isLdbExamMode?: boolean;
}

/**
 * Answer response section to respond with number.
 */
export const NumberResponseForm = (props: Props) => {
  const {
    answerBlockId,
    identifier,
    isReadonly = false,
    attachmentEnabled,
    isLdbExamMode,
  } = props;
  const snapshot = useAppSelector((state) =>
    selectAnswerSnapshot(state, answerBlockId)
  );
  const dispatch = useAppDispatch();

  const answerFloat = snapshot?.answerFields
    ? snapshot.answerFields[identifier]?.[0]
    : "";

  const answerBlock = readAnswerBlock(answerBlockId);

  const setValue = (number: string) => {
    const newVersion =
      snapshot?.version === undefined ? 0 : snapshot.version + 1;
    const newSnapshot: Snapshot = {
      version: newVersion,
      answerFields: {
        [props.identifier]: [number],
      },
    };
    dispatch(setLocalSnapshot({ answerBlockId, snapshot: newSnapshot }));
  };

  return (
    <div className={styles.shortAnswerForm}>
      <div className={styles.shortResponse}>
        <PhraseInput
          type="number"
          placeholder="Write your answer here..."
          onChange={(event) => {
            setValue(event.target.value);
          }}
          value={answerFloat}
          disabled={isReadonly}
          aria-disabled={isReadonly}
        />
        <Spacer spacing={24} />
        {attachmentEnabled && props.answerBlockId && (
          <WorkAttachmentSection
            answerBlockId={props.answerBlockId}
            attachments={answerBlock?.blockAttachments || []}
            disabled={props.isReadonly}
            ldbExamMode={isLdbExamMode}
            mode={"minimal"}
          />
        )}
      </div>
    </div>
  );
};
